import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs'
import { ApiService } from 'src/app/shared/services/apiService.service';
import { NgxSpinnerService } from "ngx-spinner";
import { SafeResourceUrl } from "@angular/platform-browser";
import { SkeletonService } from 'src/app/shared/services/skeleton.service';

import { OwlOptions } from 'ngx-owl-carousel-o';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-customer-stories',
  templateUrl: './customer-stories.component.html',
  styleUrls: ['./customer-stories.component.scss']
})
export class CustomerStoriesComponent implements OnInit {
  sub: Subscription = new Subscription
  safeUrl!: SafeResourceUrl;
  environment1 = environment.s3bucket.url;
  customerStoriesList: any;
  videoType: any;
  customerStories: any = [];
  count: number = 0;
  showLoader: any = false;
  productLoaded: boolean = false;

  constructor(private apiService: ApiService, private spinner: NgxSpinnerService,public skeletonService: SkeletonService) { }

  ngOnInit(): void {
    this.getCustomerStories()
  }
  getCustomerStories() {
    let data = {
      "action_type": "VIDEO",
      "offset": 0,
      "size":3
    }
    this.spinner.show()
    this.showLoader = true;
    this.sub.add(this.apiService.getCustomerStories(data).subscribe({
      next: (response: any) => {
        this.showLoader = false;
        if (response.success) {
          this.customerStoriesList = response.data
          this.spinner.hide()
          this.showLoader = false;
          this.productLoaded = true;
        }
        else {
          this.spinner.hide()
          this.showLoader = false;
          this.productLoaded = true;
        }
      },
      error: () => {
        this.spinner.hide()
        this.showLoader = false;
        this.productLoaded = true;
      },
      complete: () => { }
    }))
  }

  videoUrl: string;
  vedioModal(url: string) {
    this.videoUrl = ''
    this.videoUrl = url;
  }

  closeVideoModal() {
    this.videoUrl = ''
  }

  getURL(URL){
    let url = URL.includes('https://youtu.be/') ? URL?.replace('https://youtu.be/', '') :
     URL.includes('https://www.youtube.com/watch?v=') ? URL?.replace('https://www.youtube.com/watch?v=', '') :
     URL.includes('https://www.youtube.com/embed/') ? URL?.replace('https://www.youtube.com/embed/', '') : URL;
     return url;
    }

    customerstoriesoption: OwlOptions = {
      autoWidth: true,
      mouseDrag: true,
      touchDrag: true,
      pullDrag: true,
      dots: true,
      navSpeed: 700,
      margin: 24,
      navText: [
        `<img alt="left" src=${this.environment1}assets/images/c-arrow-left.svg>`,
        `<img alt="right" src=${this.environment1}assets/images/c-arrow-right.svg>`
     ],
      responsive: {
        0: {
          items: 1,
          nav:false
        },
        400: {
          items: 1,
          nav:false
        },
        600: {
          items: 1,
          nav:false
        },
        940: {
          items: 1
        },
        1199:{
          items: 1
        }
      },
      nav: true
    }


}

export interface videoBlogData {

  description: string;
  yt_url: any;
  image_url: string;
  ppl: any;

}
